import React from 'react';
import { withRouter } from 'react-router';
import queryString from 'query-string';
import SEOHead from '../../components/seo/seo-head';
import { SEO_CONFIG, SITE_URL } from '../../constants/seo-config';
import AuthMixin from '../../mixins/authenticationMixin';
import AppStore from '../../stores/stores';

import ExploreAll from '../../components/banners/explore-all';
import './marketing-explore-page.scss';

class MarketingExplorePage extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount() {
    setTimeout(() => window.scrollTo(0, 0));

    this.resolveUrlParams();
    this.loadChapterSEO();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.location.search !== this.props.location.search ||
      prevProps.location.pathname !== this.props.location.pathname
    ) {
      this.resolveUrlParams();
      this.loadChapterSEO();
    }
  }

  loadChapterSEO() {
    const chapterSlug = this.props.params && this.props.params.id;

    if (!chapterSlug) {
      if (this.state.chapter) this.setState({ chapter: null });
      return;
    }

    AppStore.getChapterByID(chapterSlug, this.props.userApiRequest, {
      onSuccess: ({ data }) => this.setState({ chapter: data }),
      onError: () => this.setState({ chapter: null }),
    });
  }

  resolveUrlParams() {
    const { search } = this.props.location;
    const params = queryString.parse(search);
    
    if (params.open) {
      // Handle opening a specific category
      this.setState({ filterCategory: params.open });
    }
  }



  render() {
    const chapter = this.state.chapter;
    const chapterSlug = this.props.params && this.props.params.id;
    const chapterTitle = chapter && chapter.title;
    const seo = chapterTitle ? {
      title: `${chapterTitle} Neurology Checklists | Neurochecklists`,
      description: `Explore evidence-based neurology topics and fully referenced clinical checklists covering ${chapterTitle}.`,
      canonical: `${SITE_URL}/explore/chapters/${chapterSlug}`,
      ogType: 'website'
    } : SEO_CONFIG.explore;

    return (
      <div className="explore-page">
        <SEOHead {...seo} />

        <section className="explore-top">
          <div className="container">
            <div className="section-head">
              <div className="eyebrow">
                <div className="eyebrow-line"></div>
                <span className="eyebrow-text">Explore the database</span>
                <div className="eyebrow-line"></div>
              </div>
              <h1>Every checklist, <em>organised by specialty</em></h1>
              <p>Browse the full Neurochecklists database by category, chapter and topic.</p>
            </div>


          </div>
        </section>

        <section className="section section-tight explore-main">
          <div className="container explore-layout">
            <section className="explore-results">
              <ExploreAll />
            </section>
          </div>
        </section>
      </div>
    );
  }
}

export default withRouter(AuthMixin(MarketingExplorePage));
